module.exports = __webpack_public_path__ + "static/media/certificado.b34c5faa.svg";